module.exports = __webpack_public_path__ + "img/brandCategoryImg.ac4ba1ec.png";